import { render, staticRenderFns } from "./BookBy.vue?vue&type=template&id=aeb0a436&"
import script from "./BookBy.vue?vue&type=script&lang=js&"
export * from "./BookBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports